import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'antd';
import { useGlobalState } from '../GlobalState';
import SelectDate from './SelectDate';
import SelectTime from './SelectTime';
import moment from 'moment/moment';

export default function SelectDatesAndTimes({ fishery_id }) {
  const [userSelectedLakeId] = useGlobalState('userSelectedLakeId');
  const [fisheryInfo] = useGlobalState('fisheryInfo');
  const [lakeDetails] = useGlobalState('lakeDetails');
  const [userSelectedPakage] = useGlobalState('userSelectedPakage');
  const [lakeExclusive] = useGlobalState('lakeExclusive');
  const [lakeInfo] = useGlobalState('lakeInfo');

  const [inFlightTimeRequests, setInFlightTimeRequests] = useState(0);
  const registerTimeRequest = () => setInFlightTimeRequests((prev) => prev + 1);
  const unregisterTimeRequest = () =>
    setInFlightTimeRequests((prev) => Math.max(prev - 1, 0));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const is_exotic_arapaima_lake =
    userSelectedLakeId === 'a4688274-3f67-40a5-be8d-a8dc51c053b3';
  const [maxBookableDate, maxBookableMessage] = useMemo(() => {
    let messageReason = '';
    let max_date = new Date();
    if (fisheryInfo?.booking_days_is_active && lakeExclusive) {
      lakeInfo.forEach((lake) => {
        if (lake.id === userSelectedLakeId) {
          max_date.setDate(
            max_date.getDate() + lake.lake_exclusive_booking_days
          );
        }
      });
    } else if (
      fisheryInfo?.booking_days_is_active &&
      fisheryInfo?.booking_days > 0
    ) {
      max_date.setDate(max_date.getDate() + fisheryInfo.booking_days);
      messageReason = `${fisheryInfo.booking_days} days in advance`;
    } else if (
      fisheryInfo?.booking_date_is_active &&
      fisheryInfo?.booking_date
    ) {
      max_date = new Date(fisheryInfo.booking_date);
    } else if (fishery_id === '10201' || fishery_id === '10832') {
      const currentYear = new Date().getFullYear();
      // Dec. 31st next year
      max_date = new Date(currentYear + 1, 11, 31);
    } else {
      // 1 year from now
      max_date.setFullYear(max_date.getFullYear() + 1);
    }
    if (!messageReason) {
      messageReason = `up to ${moment(max_date).format('Do MMMM YYYY')}`;
    }
    const message = `At ${fisheryInfo.venue_name}, you can only book ${messageReason}. Please select different dates.`;
    return [max_date, message];
  }, [fisheryInfo, fishery_id, lakeExclusive, lakeInfo, userSelectedLakeId]);

  const maxAvailabilityDate = useMemo(() => {
    let max_date = new Date();
    if (
      fisheryInfo?.availability_days_is_active &&
      fisheryInfo?.availability_days > 0
    ) {
      max_date.setDate(max_date.getDate() + fisheryInfo?.availability_days);
    } else if (
      fisheryInfo?.availability_date_is_active &&
      fisheryInfo?.availability_date
    ) {
      max_date = new Date(fisheryInfo?.availability_date);
    } else {
      max_date.setFullYear(max_date.getFullYear() + 1);
    }
    return max_date;
  }, [fisheryInfo]);

  return (
    <div>
      <Row
        id='booking-day-picker'
        className={'pd-left-15 pd-right-15'}
        justify='space-between'
      >
        <h1 className='fs-27 gBold black'>
          Almost there! Time to select your{' '}
          {is_exotic_arapaima_lake ? 'date!' : 'dates and times.'}
        </h1>
        <Col span={24}>
          <SelectDate
            fishery_id={fishery_id}
            maxBookableDate={maxBookableDate}
            maxBookableErrorMessage={maxBookableMessage}
            maxVisibleDate={maxAvailabilityDate}
            customSlotId={
              lakeDetails?.custom_slot_days?.[userSelectedPakage - 1]?.id
            }
            registerTimeRequest={registerTimeRequest}
            unregisterTimeRequest={unregisterTimeRequest}
          />
        </Col>
        <Col span={24} className='select-time-container'>
          <SelectTime
            fishery_id={fishery_id}
            loading={Boolean(inFlightTimeRequests)}
          />
        </Col>
      </Row>
    </div>
  );
}
